import React from "react";

import "./Styles.css";
import WebDocSideNavLinks from "./components/WebDocSideNavLinks";
import WebClinicSideNavLinks from "./components/WebClinicSideNavLinks";
import WebAdminSideNavLinks from "./components/WebAdminSideNaveLinks";

const WebSideNav = (props) => {
    // Don't render sidenav for patients
    if (props.role === "P" || props.role === "patient" || props.role === "Patient") {
        return null;
    }

    const loadNav = () => {
        switch (props.role) {
            case "Doctor":
                return <WebDocSideNavLinks handleLogout={props.handleLogout} />;
            case "Clinic":
                return <WebClinicSideNavLinks handleLogout={props.handleLogout} />;
            case "Admin":
                return <WebAdminSideNavLinks handleLogout={props.handleLogout} />;
            default:
                return null;
        }
    };
    return (
        <div className="webSideNav">
            <div className="wsnBlock">{loadNav()}</div>
        </div>
    );
};

export default WebSideNav;
